<script lang="ts">
    import { Chart, type ChartConfiguration } from "chart.js";
    import { onDestroy, onMount } from "svelte";
    import { extractFromTimeToTotalsMap, getDefaultMinimalisticStyle, setMinMaxStep } from "../../utility/GraphHelper.svelte";

    import jQuery from "jquery";
    import type { IStatsController } from "../../controller";
    import { ConfigurationManager } from "../../ConfigurationManager";
    import type { Totals } from "../../model/StatsTotals";
    import { buildContinuesTimeFrameLabels, extendTimedKeys, getOneWeekAgo, getStartOfTomorrow, secondsToDurationString, secondsToShortForm } from "../../utility/DateTimeHelper";

    interface Props {
        bookingId: string;
        totalEarnings?: number;
    }

    let { bookingId, totalEarnings = 0 }: Props = $props();
    let totalImpressions: number = $state(0);
    let totalImpressionTime: number = $state(0);
    let totalUniquePlayers: number = $state(0);

    let statsController: IStatsController = ConfigurationManager.getInstance().statsController;

    let timeoutUpdateTotals = undefined;

    function updateTotals() {
        statsController.getTotalsForBooking(bookingId).then((totals: Totals) => {
            totalImpressionTime = totals.DurationS ? totals.DurationS : 0;
            totalImpressions = totals.CountImpressions ? totals.CountImpressions : 0;
            totalUniquePlayers = totals.CountUniquePlayers ? totals.CountUniquePlayers : 0;
        }).finally(() => {
            timeoutUpdateTotals = setTimeout(updateTotals, 2000)
        });
    }

    let chartTotalImpressions: Chart;
    let chartDailyUniqueUsers: Chart;
    let chartDailyDuration: Chart;
    let chartDailyEarnings: Chart;

    function createBaseConfig(name: string) : ChartConfiguration {
        let simpleLineChartConfig: ChartConfiguration = getDefaultMinimalisticStyle();

        simpleLineChartConfig.data.labels = [...Array(12).keys()];
        simpleLineChartConfig.type = "bar";
        simpleLineChartConfig.data.datasets[0].data = Array.from({ length: 12 }, () => Math.floor(Math.random() * 24000))
        simpleLineChartConfig.data.datasets[0].label = "Impressions";
        simpleLineChartConfig.options.scales["x"].type = "time";

        return simpleLineChartConfig;
    }

    onMount(() => {

        chartTotalImpressions = new Chart(jQuery("#totalImpressionsChart").get(0) as HTMLCanvasElement, createBaseConfig("Total Daily Impressions"));
        chartDailyUniqueUsers = new Chart(jQuery("#totalUniqePlayersChart").get(0) as HTMLCanvasElement, createBaseConfig("Total Daily Unique Users"));
        chartDailyEarnings = new Chart(jQuery("#totalEarningsChart").get(0) as HTMLCanvasElement, createBaseConfig("Total Daily Earnings"));
        chartDailyDuration = new Chart(jQuery("#totalImpressionDurationChart").get(0) as HTMLCanvasElement, createBaseConfig("Total Daily Duration"));

        let all = buildContinuesTimeFrameLabels(getOneWeekAgo(), getStartOfTomorrow(), "1d");

        statsController.getImpressionStatsForBooking(bookingId, getOneWeekAgo(), getStartOfTomorrow(), "1d").then((totalsMap: Map<Date,Totals>) => {
            let converted = extractFromTimeToTotalsMap(totalsMap);

            chartTotalImpressions.data.labels = Array.from(converted.count.keys());
            chartTotalImpressions.data.datasets[0].data = Array.from(converted.count.values());
            setMinMaxStep(chartTotalImpressions, getOneWeekAgo(),  getStartOfTomorrow(), "1d");
            chartTotalImpressions.update();

            chartDailyUniqueUsers.data.labels = Array.from(converted.uniquePlayers.keys());
            chartDailyUniqueUsers.data.datasets[0].data = Array.from(converted.uniquePlayers.values());
            setMinMaxStep(chartDailyUniqueUsers, getOneWeekAgo(),  getStartOfTomorrow(), "1d");
            chartDailyUniqueUsers.update();

            chartDailyDuration.data.labels = Array.from(converted.duration.keys());
            chartDailyDuration.data.datasets[0].data = Array.from(converted.duration.values());
            setMinMaxStep(chartDailyDuration, getOneWeekAgo(),  getStartOfTomorrow(), "1d");
            chartDailyDuration.update();
        });

        statsController.getDailyEarnings(bookingId, getOneWeekAgo(), getStartOfTomorrow()).then((dailyEarningsMap: Map<Date,number>) => {
            chartDailyEarnings.data.labels = Array.from(dailyEarningsMap.keys());
            chartDailyEarnings.data.datasets[0].data = Array.from(dailyEarningsMap.values());
            setMinMaxStep(chartDailyEarnings, getOneWeekAgo(),  getStartOfTomorrow(), "1d");
            chartDailyEarnings.update();
        });

        // statsController.getImpressionsForBooking(bookingId, getOneWeekAgo(), getStartOfTomorrow(), "1d").then((entries: Map<Date,number>) => {
        //     // entries = extendTimedKeys( getOneWeekAgo(), getStartOfTomorrow(), "1d", entries);
        //     simpleLineChartConfig.data.labels = Array.from(entries.keys());
        //     simpleLineChartConfig.data.datasets[0].data = Array.from(entries.values());
        //     setMinMaxStep(chartTotalImpressions, getOneWeekAgo(),  getStartOfTomorrow(), "1d");
        //     chartTotalImpressions.update();
        // });

        updateTotals();
    });

    onDestroy(() => {
        if(timeoutUpdateTotals) {
            clearTimeout(timeoutUpdateTotals);
        }
    });
</script>



<div class="row px-2">
    <div class="col-xxl-5">
        <div class="row px-2">
            <div class="col-md-6 px-0">
                <!-- Card -->
                <div class="card ">
                    <div class="card-body">
                        <div class="row justify-content-between">
                            <div class="col-6">
                                <!-- Title -->
                                <h5 class="text-uppercase text-body-secondary fw-semibold mb-2 d-flex align-items-center" style="height: 3em;">
                                    Impressions

                                    <!-- Icon -->
                                    <a href="javascript: void(0);" class="ms-2 text-secondary" data-bs-toggle="tooltip" title="Impressions are a metric defined as the total number of add impressions viewed.">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="14" width="14"><path d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,0,1,0,2Z" style="fill: currentColor" /></svg>
                                    </a>
                                </h5>

                                <!-- Subtitle -->
                                <h3 class="mb-0">{totalImpressions.toLocaleString()}</h3>

                                <!-- Comment -->
                                <p class="fs-6 text-body-secondary mb-0 text-truncate">
                                    <!-- Badge -->
                                    <span class="badge text-bg-danger-soft fs-6 fw-bold mb-n1">
                                        <svg viewBox="0 0 24 24" height="10" width="10" xmlns="http://www.w3.org/2000/svg"><path d="M23.25 11.25L23.25 18 16.5 18" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /><path d="M23.25,18l-7.939-7.939a1.5,1.5,0,0,0-2.122,0l-3.128,3.128a1.5,1.5,0,0,1-2.122,0L.75,6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /></svg>
                                        9.2%
                                    </span>
                                    from 134,969
                                </p>
                            </div>
                            <div class="col-6 pe-0">
                                <!-- Chart -->
                                <div class="chart-container w-100 h-65px">
                                    <canvas id="totalImpressionsChart"></canvas>
                                </div>
                            </div>
                        </div>
                        <!-- / .row -->
                    </div>
                </div>
            </div>

            <div class="col-md-6 px-2">
                <!-- Card -->
                <div class="card ">
                    <div class="card-body">
                        <div class="row justify-content-between">
                            <div class="col-6">
                                <!-- Title -->
                                <h5 class="text-uppercase text-body-secondary fw-semibold mb-2 d-flex align-items-center" style="height: 3em;">
                                    Unique Players

                                    <!-- Icon -->
                                    <a href="javascript: void(0);" class="ms-2 text-secondary" data-bs-toggle="tooltip" title="Impressions are a metric defined as the total number of add impressions viewed.">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="14" width="14"><path d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,0,1,0,2Z" style="fill: currentColor" /></svg>
                                    </a>
                                </h5>

                                <!-- Subtitle -->
                                <h3 class="mb-0">{totalUniquePlayers.toLocaleString()}</h3>

                                <!-- Comment -->
                                <p class="fs-6 text-body-secondary mb-0 text-truncate">
                                    <!-- Badge -->
                                    <span class="badge text-bg-danger-soft fs-6 fw-bold mb-n1">
                                        <svg viewBox="0 0 24 24" height="10" width="10" xmlns="http://www.w3.org/2000/svg"><path d="M23.25 11.25L23.25 18 16.5 18" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /><path d="M23.25,18l-7.939-7.939a1.5,1.5,0,0,0-2.122,0l-3.128,3.128a1.5,1.5,0,0,1-2.122,0L.75,6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /></svg>
                                        9.2%
                                    </span>
                                    from 134,969
                                </p>
                            </div>
                            <div class="col-6 pe-0">
                                <!-- Chart -->
                                <div class="chart-container w-100 h-65px">
                                    <canvas id="totalUniqePlayersChart"></canvas>
                                </div>
                            </div>
                        </div>
                        <!-- / .row -->
                    </div>
                </div>
            </div>
        </div>
        <!-- / .row -->
    </div>

    <div class="col-xxl-7">
        <div class="row">
            <div class="col-md-6 ps-0 pe-4">
                <!-- Card -->
                <div class="card ">
                    <div class="card-body">
                        <div class="row justify-content-between">
                            <div class="col-6">
                                <!-- Title -->
                                <h5 class="text-uppercase text-body-secondary fw-semibold mb-2 d-flex align-items-center" style="height: 3em;">
                                    Impression Duration

                                    <!-- Icon -->
                                    <a href="javascript: void(0);" class="ms-2 text-secondary" data-bs-toggle="tooltip" title="Impressions are a metric defined as the total number of add impressions viewed.">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="14" width="14"><path d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,0,1,0,2Z" style="fill: currentColor" /></svg>
                                    </a>
                                </h5>

                                <!-- Subtitle -->
                                <h3 class="mb-0">{totalImpressionTime.toLocaleString()} s</h3>

                                <!-- Comment -->
                                <p class="fs-6 text-body-secondary mb-0 text-truncate">
                                    <!-- Badge -->
                                    <span class="badge text-bg-danger-soft fs-6 fw-bold mb-n1">
                                        <svg viewBox="0 0 24 24" height="10" width="10" xmlns="http://www.w3.org/2000/svg"><path d="M23.25 11.25L23.25 18 16.5 18" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /><path d="M23.25,18l-7.939-7.939a1.5,1.5,0,0,0-2.122,0l-3.128,3.128a1.5,1.5,0,0,1-2.122,0L.75,6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /></svg>
                                        9.2%
                                    </span>
                                    from 134,969
                                </p>
                            </div>
                            <div class="col-6 pe-0">
                                <!-- Chart -->
                                <div class="chart-container w-100 h-65px">
                                    <canvas id="totalImpressionDurationChart"></canvas>
                                </div>
                            </div>
                        </div>
                        <!-- / .row -->
                    </div>
                </div>
            </div>


            <div class="col-md-6 px-0">
                <!-- Card -->
                <div class="card ">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-6">
                                <!-- Title -->
                                <h5 class="text-uppercase text-body-secondary fw-semibold mb-2" style="height: 3em;">Total</h5>

                                <!-- Subtitle -->
                                <h3 class="mb-0">{totalEarnings.toLocaleString()} €</h3>

                                <!-- Comment -->
                                <p class="fs-6 text-body-secondary mb-0 text-truncate">
                                    <!-- Badge -->
                                    <span class="badge text-bg-success-soft fs-6 fw-bold mb-n1">
                                        <svg viewBox="0 0 24 24" height="10" width="10" xmlns="http://www.w3.org/2000/svg"><path d="M23.25 12.75L23.25 6 16.5 6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /><path d="M23.25,6l-7.939,7.939a1.5,1.5,0,0,1-2.122,0l-3.128-3.128a1.5,1.5,0,0,0-2.122,0L.75,18" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" /></svg>
                                        12%
                                    </span>
                                    from $65,934
                                </p>
                            </div>

                            <div class="col-6 pe-0">
                                <!-- Chart -->
                                <div class="chart-container h-70px">
                                    <canvas id="totalEarningsChart"></canvas>
                                </div>
                            </div>
                        </div>
                        <!-- / .row -->
                    </div>
                </div>
            </div>
        </div>
        <!-- / .row -->
    </div>
</div>